import React from 'react';
import { TUseTrading } from './useTrading';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const TradingContext = React.createContext<TUseTrading>(null);
